<template>
  <div class="card-body">
    <div class="row">

      <div class="form-group col-sm-2">

        <label>Cd Crtor</label>

        <b-form-group :invalid-feedback="violations['cdCrtor']" :state="!violations['']">

          <b-form-input v-model="ssv2303ConfiAutoFncra.cdCrtor" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Inico Vigen</label>

        <b-form-group :invalid-feedback="violations['dtInicoVigen']" :state="!violations['']">

          <date-picker v-model="ssv2303ConfiAutoFncra.dtInicoVigen" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Dt Fim Vigen</label>

        <b-form-group :invalid-feedback="violations['dtFimVigen']" :state="!violations['']">

          <date-picker v-model="ssv2303ConfiAutoFncra.dtFimVigen" type="date" value-type="format" lang="pt-br" format="DD/MM/YYYY" placeholder="" :required="true" :readonly="false"></date-picker>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Tp Forma Pagto</label>

        <b-form-group :invalid-feedback="violations['tpFormaPagto']" :state="!violations['']">

          <b-form-input v-model="ssv2303ConfiAutoFncra.tpFormaPagto" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

      <div class="form-group col-sm-2">

        <label>Ds Sigla Fncra</label>

        <b-form-group :invalid-feedback="violations['dsSiglaFncra']" :state="!violations['']">

          <b-form-input v-model="ssv2303ConfiAutoFncra.dsSiglaFncra" type="text" placeholder="" :required="true" :readonly="false"></b-form-input>

        </b-form-group>
      </div>

    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import store from "@/store";
  
  import { 
  	
      } from "@/store/actions.type";
      
  export default {
    props: ['ssv2303ConfiAutoFncra', 'violations'],
    computed: {
  	    ...mapGetters([
  	         
  	         ]),
    },
    methods:{
        
    },
    mounted(){
      
    }
  }
</script>